const denounceModal = {
  show: false,
  entityId: "",
  reportedUserId: 0,
  contentType: "",
};

export default denounceModal;